import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { TSafetyInfoMgmt } from '../../../type';

const SafetyInfoContentItem: React.FC<TSafetyInfoMgmt & { onEdit: () => void }> = ({
    criticalSafetyInformation,
    generalSafetyConsiderations,
    onEdit,
}) => {
    return (
        <div className={s.contentItem}>
            <div className={s.header}>
                <h3 className={s.title}>ADHD</h3>
                <Button
                    onClick={onEdit}
                >
                    Edit
                </Button>
            </div>

            <div className={s.content}>
                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Critical safety information</div>
                    <div className={s.dataValue}>{criticalSafetyInformation}</div>
                </div>

                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>General safety considerations</div>
                    <div className={s.dataValue}>
                        <ul className={s.safetyConsiderationsList}>
                            {generalSafetyConsiderations.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SafetyInfoContentItem;
